import { Box, Menu } from '@mui/material';
import { styled } from '@mui/material/styles';

interface TextAreaRendererProps {
  isEmptyRequiredValue?: boolean;
}

export const TextAreaRenderer = styled(Box)<TextAreaRendererProps>(({ isEmptyRequiredValue }) => ({
  width: '100%',
  '.MuiInput-input': {
    pointerEvents: 'none!important',
  },
  '&': !isEmptyRequiredValue && {
    '.inline-field .Mui-disabled': {
      cursor: 'pointer !important',
    },
  },
}));

export const StyledMenu = styled(Menu)(() => ({
  '.MuiPaper-root': {
    overflow: 'hidden',
    minHeight: '0!important',
    minWidth: '0!important',
    boxShadow: 'none!important',
  },
  '.MuiList-root': {
    padding: '0',
  },
  '.Mui-focused': {
    border: 'none !important',
    color: `grey!important`,
    font: 'robotoRegular',
  },
}));

export const QueueTextAreaWrapper = styled('div')(() => ({
  width: '500px !important',
  position: 'relative',
}));

export const MissingTemplateTooltipWrapper = styled('div')(() => ({
  paddingLeft: '8px',
  '.MuiTypography-root': {
    textAlign: 'left',
  },
}));
